import styled, { css } from "styled-components";
import { Theme } from "interfaces/theme";

interface IContainer {
  mode: Theme;
}
export const Container = styled.main<IContainer>`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 1s ease;

  ${({ mode }) =>
    mode === "light" &&
    css`
      background-color: #e8c7d1;
    `}

  ${({ mode }) =>
    mode === "dark" &&
    css`
      background-color: #1a1a1a;
    `}
`;

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
`;
